exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\n.page-block {\n  width: 100%;\n  margin: 0 0 0 auto;\n  -webkit-transition: all 0.4s cubic-bezier(0, 0, 0, 1);\n  transition: all 0.4s cubic-bezier(0, 0, 0, 1);\n  background-color: #f0f0f0;\n  height: calc(100% - 40px - 65px);\n  position: relative; }\n.page-block {\n  padding-bottom: 68px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #f0f0f0; }\n.scroll-y {\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n.layout-header {\n  background-color: white; }\n.layout-ui {\n  border-bottom: 0.1px solid transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3053/wa3053.component.scss
// module id = ../../../../../src/app/pages/wa3Shipment/wa3053/wa3053.component.scss
// module chunks = main